module.exports = __webpack_public_path__ + "static/ADS_Repo-13f9f09e737d6d3bb072078443ca26a5.jpg";